import { CurrentUserEntriesAndStats } from 'components/dashboard/EntriesAndStats/EntriesAndStats';
import HeaderProfile from 'components/dashboard/header-profile/HeaderProfile';
import MainLayout from 'components/layout/MainLayout';
import { useAuthRedirectEffect } from 'hooks/account/useAuthRedirect';
import { observer } from 'mobx-react-lite';
import { Fragment, ReactElement, useEffect, useState } from 'react';

import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import { DashboardInstagramFeed } from 'components/dashboard/DashboardInstagramFeed';
import DashboardLinks from 'components/dashboard/DashboardLinks';
import { MoreWaysToWin } from 'components/dashboard/MoreWaysToWin';
import { CurrentUserTreeProgression } from 'components/dashboard/TreeProgression';
import WinsAndMonthly from 'components/dashboard/WinsAndMonthly';
import YourWishlist from 'components/dashboard/your-wishlist/YourWishlist';
import styles from './dashboard.module.css';

interface Dashboard2026Props {}

const Dashboard2026 = observer((_props: Dashboard2026Props) => {
  useAuthRedirectEffect('/dashboard');
  const [dashboardLoading, setDashboardLoading] = useState(true);

  useEffect(() => {
    if (dashboardLoading) {
      setTimeout(() => {
        setDashboardLoading(false);
      }, 1000);
    }
  }, [dashboardLoading]);

  return (
    <MainLayout limitItemWidths noHeaderDropShadow>
      <div className={`aboutUsTypographyReset ${styles.outerContainer}`}>
        {/* PROFILE INFO & EDIT PROFILE */}
        <HeaderProfile loading={dashboardLoading} />
        {/* ENTRIES & STATS */}
        <CurrentUserEntriesAndStats loading={dashboardLoading} />
        {/* YOUR WINS & MONTHLY 10k */}
        <WinsAndMonthly loading={dashboardLoading} />
        {/* MORE WAYS TO WIN (TOKEN TOWN DRAWS) */}
        <MoreWaysToWin loading={dashboardLoading} />

        {/* TREES & WISHLIST */}
        {!dashboardLoading && (
          <AboutUsModule background="grey" withReducedPadding>
            <AboutUsSiteContainer overlapAbove twoColumn>
              <div className={styles.dashboardTreeContainer}>
                <CurrentUserTreeProgression />
              </div>
              <div className={styles.dashboardWishlistContainer}>
                <YourWishlist />
              </div>
            </AboutUsSiteContainer>
          </AboutUsModule>
        )}

        {/* INSTAGRAM FEED */}
        <DashboardInstagramFeed loading={dashboardLoading} />

        {/* LINKS */}
        <DashboardLinks loading={dashboardLoading} />
      </div>
    </MainLayout>
  );
});

export default Dashboard2026;
